import React from 'react';
import { Drawer, DrawerContent, DrawerTrigger } from 'components/ui/drawer';
import { MoreHorizontal } from 'lucide-react';

export type IDataTableDrawer = {
  icon?: React.ReactNode;
  trigger?: React.ReactNode;
  content?: React.ReactNode;
  asChild?: boolean;
};

export type DataTableDrawersProps = {
  actions: IDataTableDrawer[];
};

export const DataTableDrawer: React.FC<DataTableDrawersProps> = ({
  actions,
}) => {
  return (
    <Drawer>
      <DrawerTrigger asChild={actions[0].asChild}>
        {actions[0].trigger || (
          <MoreHorizontal className="h-5 w-5 text-slate-500" />
        )}
      </DrawerTrigger>
      <DrawerContent className="text-center">
        {actions[0].content}
      </DrawerContent>
    </Drawer>
  );
};
